module.exports = __webpack_public_path__ + "static/img/hyundai-kefico-ev-charger.f0dfd6e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/hyundai-kefico-ev-charger.jpg
// module id = E2ZV
// module chunks = 0